import api from './api';

/**
 * Consulta pública de documento digital (Receita, Atestado, Requisição)
 * Não engole erro de rede/503 para que o SWR e o ServiceUnavailableAlert tratem.
 */
export async function consultarDocumentoPublico({ tipo, codDoc, codPac }) {
  const { data } = await api.get(`/validacao/${tipo}/${codDoc}/paciente/${codPac}`);
  return data;
}

/**
 * Realiza a baixa (dispensação) de uma receita digital pela farmácia.
 */
export async function baixarReceitaPublica({ codReceita, codPaciente, cpfUpdate, origem }) {
  const { data } = await api.put(`/paciente/receita/${codReceita}`, {
    origem,
    cpfUpdate,
    codPaciente,
  });
  return data;
}

/**
 * Busca os dados completos da receita baixada para impressão pela farmácia que realizou a baixa.
 */
export async function buscarReceitaFarmaciaPdf({ codPaciente, codReceita, cpfUpdate }) {
  const { data } = await api.get(
    `/paciente/${codPaciente}/receita/${codReceita}/farmacia/${cpfUpdate}`
  );
  return data;
}
